























import {
  defineComponent, ref, computed, onMounted,
} from '@vue/composition-api';
import { Popup } from 'vant';
import { RightPackageTypeEnum } from '@/api/rights/types';
import { openThirdPage } from '@/api/native/utils';
import { MembersRightsPrefix } from '@/constant';
import { SuccessOverlayImgInfo } from './contanst';

export default defineComponent({
  components: {
    Popup,
  },
  props: {
    /** 是否展示 */
    modelValue: {
      type: Boolean,
      default: false,
    },
    /** 卡类型 */
    packageType: {
      type: Number,
      default: RightPackageTypeEnum.SUPER_MEMBER_CARD,
    },
    /** 提现订单id */
    orderId: {
      type: String,
      default: '',
    },
  },
  emits: [
    /** 更新绑定值 */
    'update:modelValue',
    /** 关闭蒙层回调 */
    'close',
  ],
  setup(props, { emit }) {
    const isShow = computed({
      get: () => props.modelValue,
      set: (value) => {
        emit('update:modelValue', value);
      },
    });

    /** 将375标准下的尺寸转换为运行时实际屏幕宽度对应的像素尺寸，window.innerWidth 存在 0 的情况 */
    const vm = (size: number): number => (size / 375) * (window.innerWidth || 375);

    const time = ref<number>(3);

    const countDown = () => {
      // 每隔1000毫秒（1秒）更新倒计时值
      const intervalId = setInterval(() => {
        time.value--;

        if (time.value <= 0) {
          clearInterval(intervalId);
          isShow.value = false;
          if (props.packageType === RightPackageTypeEnum.SUPER_MEMBER_CARD && props.orderId) {
            openThirdPage(`${MembersRightsPrefix}super-member_bought.html#/super-member/bought?orderId=${props.orderId}`);
          }
          emit('close');
        }
      }, 1000);
    };

    onMounted(() => {
      countDown();
    });


    return {
      vm,
      SuccessOverlayImgInfo,
      RightPackageTypeEnum,
      isShow,
      time,
    };
  },
});
